import axios from 'axios';
import { getApiUrl } from '../config/runtime';

const getApiBaseUrl = () => getApiUrl();

const getApi = () => {
  const api = axios.create({
    baseURL: getApiBaseUrl(),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add token to requests
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  return api;
};

export interface Device {
  id: number;
  user_id: number | null;
  device_hash: string;
  device_name?: string;
  device_type?: string;
  created_at: string;
  updated_at: string;
}

const deviceService = {
  getDevices: async (): Promise<Device[]> => {
    const response = await getApi().get<{ devices: Device[] }>('/devices');
    return response.data.devices;
  },

  addDevice: async (deviceHash: string): Promise<Device> => {
    const response = await getApi().post<{ device: Device }>('/devices/add', {
      device_hash: deviceHash,
    });
    return response.data.device;
  },

  updateDevice: async (
    deviceId: number,
    data: { device_name?: string; device_type?: string }
  ): Promise<Device> => {
    const response = await getApi().put<{ device: Device }>(`/devices/${deviceId}`, data);
    return response.data.device;
  },

  deleteDevice: async (deviceId: number): Promise<void> => {
    await getApi().delete(`/devices/${deviceId}`);
  },

  previewColor: async (
    deviceId: number,
    red: number,
    green: number,
    blue: number,
    blink: boolean = false
  ): Promise<void> => {
    await getApi().post(`/devices/${deviceId}/preview`, {
      red,
      green,
      blue,
      blink,
    });
  },

  previewLight: async (
    deviceId: number,
    status: 0 | 1 | 2
  ): Promise<void> => {
    await getApi().post(`/devices/${deviceId}/preview-light`, {
      status,
    });
  },

  refreshDeviceLED: async (deviceId: number): Promise<void> => {
    await getApi().post(`/devices/${deviceId}/refresh`);
  },
};

export default deviceService;
